import { render } from "./OrderPaidStatusLabel.vue?vue&type=template&id=02c58dcf"
import script from "./OrderPaidStatusLabel.vue?vue&type=script&lang=js"
export * from "./OrderPaidStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__